"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttachText = exports.getWholesaleLimit = exports.getCollectLimit = exports.getSaleLimit = exports.getShipmentPeriod = void 0;
/**
 * 获取发运周期
 * @param  {number} val
 * @return {string}
 */
function getShipmentPeriod(val) {
    const hoursPerDay = 24;
    if (val <= hoursPerDay * 3) {
        return `${val}小时`;
    }
    const days = Math.ceil(val / hoursPerDay);
    if (days <= 60) {
        return `${days}天`;
    }
    const months = Math.round(days / 30);
    return `${months}月`;
}
exports.getShipmentPeriod = getShipmentPeriod;
/**
 * 获取销售限额
 * @param  {number} val 销量
 * @param  {string} val 前缀
 * @return {string}
 */
function getSaleLimit(val, prefix = '已售', minNum, batch) {
    const units = ['', '万', '亿'];
    const unitIndex = Math.floor(Math.log10(val) / 4);
    const displayValue = val / Math.pow(10, unitIndex * 4);
    if (unitIndex < 1) {
        if (val < 10)
            return batch ? getWholesaleLimit(minNum) : `${prefix}10件以下`;
        if (val < 10000)
            return `${prefix}${val}件`;
    }
    if (unitIndex < units.length) {
        const roundedValue = Math.round(displayValue * 10) / 10;
        return `${prefix}${roundedValue}${units[unitIndex]}+件`;
    }
    return `${prefix}太多件`;
}
exports.getSaleLimit = getSaleLimit;
function getCollectLimit(val, minNum) {
    if (val < 10)
        return getWholesaleLimit(minNum);
    return `${val}人想买`;
}
exports.getCollectLimit = getCollectLimit;
function getWholesaleLimit(val) {
    return `${val}件起批`;
}
exports.getWholesaleLimit = getWholesaleLimit;
/**
 * 获取商品附加信息
 * @param  {number|undefined}   val  销量
 * @param                       obj  其他信息
 * @return {string}
 */
function getAttachText(val, obj) {
    const { batch = true } = obj;
    if (val)
        return getSaleLimit(val, '已售', obj.minNum, batch);
    const { productAccessNum, minNum } = obj;
    if (productAccessNum)
        return getCollectLimit(productAccessNum, obj.minNum);
    return getWholesaleLimit(minNum);
}
exports.getAttachText = getAttachText;
//# sourceMappingURL=exclusive.js.map